export type StatsBoxDefaultKind = 'online' | 'winners' | 'prize';

const svgToDataUri = (svg: string) =>
  `data:image/svg+xml;utf8,${encodeURIComponent(svg.trim())}`;

export const STATS_BOX_DEFAULT_ICONS: Record<StatsBoxDefaultKind, string> = {
  online: svgToDataUri(`
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
      <defs>
        <radialGradient id="sbOnBg" cx="35%" cy="28%" r="72%">
          <stop offset="0%" stop-color="#6EE7B7"/>
          <stop offset="55%" stop-color="#10B981"/>
          <stop offset="100%" stop-color="#047857"/>
        </radialGradient>
        <linearGradient id="sbOnRing" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="#FDE68A"/>
          <stop offset="100%" stop-color="#F59E0B"/>
        </linearGradient>
      </defs>
      <circle cx="32" cy="32" r="28" fill="url(#sbOnBg)" stroke="url(#sbOnRing)" stroke-width="3"/>
      <circle cx="25" cy="24" r="7" fill="#FFFFFF"/>
      <path d="M13 44c0-6.6 5.4-12 12-12s12 5.4 12 12" fill="#FFFFFF"/>
      <circle cx="42" cy="26" r="5.5" fill="#D1FAE5"/>
      <path d="M35 44c0.6-5.1 4.6-9 9.5-9 3.5 0 6.6 1.9 8.2 4.8" fill="#D1FAE5"/>
      <circle cx="49" cy="17" r="5" fill="#22C55E" stroke="#FFFFFF" stroke-width="2"/>
    </svg>
  `),
  winners: svgToDataUri(`
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
      <defs>
        <radialGradient id="sbWinBg" cx="35%" cy="25%" r="75%">
          <stop offset="0%" stop-color="#FDE047"/>
          <stop offset="55%" stop-color="#F59E0B"/>
          <stop offset="100%" stop-color="#B45309"/>
        </radialGradient>
        <linearGradient id="sbCup" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stop-color="#FEF08A"/>
          <stop offset="100%" stop-color="#F59E0B"/>
        </linearGradient>
      </defs>
      <circle cx="32" cy="32" r="28" fill="url(#sbWinBg)" stroke="#FEF08A" stroke-width="3"/>
      <path d="M21 17h22v9c0 6.1-4.9 11-11 11s-11-4.9-11-11v-9z" fill="#FFFFFF"/>
      <path d="M21 20h-5c0 5 2.5 8 6 8.5M43 20h5c0 5-2.5 8-6 8.5" fill="none" stroke="#FFFFFF" stroke-width="3" stroke-linecap="round"/>
      <rect x="29" y="36" width="6" height="7" rx="1.5" fill="#FFFFFF"/>
      <rect x="23" y="43" width="18" height="4.5" rx="2" fill="#FFFFFF"/>
      <polygon points="32,20 33.8,23.6 37.8,24.2 34.9,27 35.6,31 32,29.1 28.4,31 29.1,27 26.2,24.2 30.2,23.6" fill="url(#sbCup)"/>
    </svg>
  `),
  prize: svgToDataUri(`
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
      <defs>
        <radialGradient id="sbPrzBg" cx="35%" cy="25%" r="75%">
          <stop offset="0%" stop-color="#DDD6FE"/>
          <stop offset="50%" stop-color="#8B5CF6"/>
          <stop offset="100%" stop-color="#4C1D95"/>
        </radialGradient>
        <linearGradient id="sbCrown" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="#FEF08A"/>
          <stop offset="50%" stop-color="#FACC15"/>
          <stop offset="100%" stop-color="#EA580C"/>
        </linearGradient>
      </defs>
      <circle cx="32" cy="32" r="28" fill="url(#sbPrzBg)" stroke="#FDE047" stroke-width="3"/>
      <path d="M15 41l4-18 13 10 13-10 4 18H15z" fill="url(#sbCrown)" stroke="#FFFFFF" stroke-width="1.8" stroke-linejoin="round"/>
      <rect x="16" y="43" width="32" height="5" rx="2.5" fill="#FDE047"/>
      <circle cx="19" cy="20" r="2.6" fill="#FEF08A"/>
      <circle cx="32" cy="17" r="3" fill="#FEF08A"/>
      <circle cx="45" cy="20" r="2.6" fill="#FEF08A"/>
    </svg>
  `),
};

const MSSQ_LEGACY_MAP: Record<string, string> = {
  'https://mssq.me/uploads/files/ff0d3453004d51bdcb63d4c85707ecc5.webp': STATS_BOX_DEFAULT_ICONS.online,
  'https://mssq.me/uploads/files/09f2033f0299e7f4172ff1d78bdc1e13.webp': STATS_BOX_DEFAULT_ICONS.winners,
  'https://mssq.me/uploads/files/e8d38d9b6da917caedd03840d4ee3e2a.webp': STATS_BOX_DEFAULT_ICONS.prize,
};

export function resolveStatsBoxIcon(rawIcon: string | undefined, index = 0): string {
  const trimmed = String(rawIcon || '').trim();
  if (trimmed && MSSQ_LEGACY_MAP[trimmed]) {
    return MSSQ_LEGACY_MAP[trimmed];
  }
  if (!trimmed || trimmed.includes('mssq.me')) {
    const order: StatsBoxDefaultKind[] = ['online', 'winners', 'prize'];
    return STATS_BOX_DEFAULT_ICONS[order[index % order.length]];
  }
  return trimmed;
}
